/** @jsxImportSource @emotion/react */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Snack, Snackbar } from '@nike/eds';

import { TranslatedCopy } from '../intl/TranslatedCopy';
import { requestsActions } from '../requests/actions';
import { requestsSelectors } from '../requests/reducer';

const UserManagementErrorSnackbar = () => {
  const dispatch = useDispatch();

  const invitationError = useSelector(requestsSelectors.invitationError);
  const updateUserError = useSelector(requestsSelectors.updateUserError);

  return (
    <Snackbar>
      {(invitationError || updateUserError) && (
        <Snack
          status='error'
          className='eds--dark'
          css={{ color: '#fff' }}
          onDismiss={() => {
            dispatch({
              type: invitationError
                ? requestsActions.clearInvitationError.name
                : requestsActions.clearUpdateUserError.name
            });
          }}
        >
          <TranslatedCopy id='userManagement.action.error' />
        </Snack>
      )}
    </Snackbar>
  );
};

export default UserManagementErrorSnackbar;
